<template>
    <b-card class="card-accent-light" header-tag="header" footer-tag="footer" no-body>
        <template v-slot:header>
            <i class="fa-regular fa-file-lines"></i> <strong> Ontslagbrief </strong>
            <div class="card-header-actions">
                <b-link class="card-header-action btn-minimize" @click="visible = !visible">
                    <i class="fa-regular" :class="visible ? 'fa-square-caret-up' : 'fa-square-caret-down'"></i>
                </b-link>
            </div>
        </template>
        <b-collapse v-model="visible">
            <ontslagbrief-base :callback="createPatientOntslagbrief" borderless />
        </b-collapse>
    </b-card>
</template>
<script>
import ComponentExtension from "@/core/components/ComponentExtension"
import OntslagbriefBase from './OntslagbriefBase'
import { mapActions } from "vuex"

export default ComponentExtension.extend({
    name: "ontslagbrief",
    components: {
        'ontslagbrief-base': OntslagbriefBase
    },
    methods: {
        ...mapActions('health', ['createPatientOntslagbrief']),
    }
})
</script>
